import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
// import { NotificationService } from '@app-services/request/notification/notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/store/app.reducers';
import { Action } from '@app-models/action.model';
import { TopbarActions } from 'src/app/core/store/actions/topbar/actions';
import _get from 'lodash/get';

@Component({
  selector: 'app-topbar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit, OnDestroy {
  @Input() avatar: string;
  public isOpen = false;
  private isOpenSubscription: Subscription;
  public customerLogo: string;
  public isMobile;
  public isTablet;
  public isDesktopDevice;
  public showSearch = true;
  public routePreload;

  // Store
  subscription: Subscription = new Subscription();
  public actions: Action[] = [];
  public actionList: Action[] = [];
  public buttonList: Action[] = [];

  constructor(
    private deviceService: DeviceDetectorService,
    private store: Store<AppState>,
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) {
    this.routePreload = router.routerState.snapshot.url;
    if (this.routePreload === '/dashboardOps') {
      this.showSearch = false;
    }
  }

  ngOnInit() {
    this.deviceFunction();

    // Set Logo
    if (this.isMobile) {
      this.customerLogo =
        '../../../../../assets/images/logos/LSS_LogoSmall.svg';
    } else {
      this.customerLogo = '../../../../../assets/images/logos/LSS_Logo.svg';
    }

    // Read Actions
    this.subscription = this.store.select('topBar').subscribe(({ actions }) => {
      this.actions = [...actions];
      this.actionList = this.actions.filter((action) => action.type === 'list');
      this.buttonList = this.actions.filter(
        (action) => action.type === 'button'
      );
    });

    this.showSearchBar();
  }

  showSearchBar() {
    this.router.events.subscribe((val: any) => {
      if (
        (val.url === '/dashboardOps' ||
          this.routePreload === '/dashboardOps') &&
        val.url === '/dashboardOps' &&
        val.urlAfterRedirects === '/dashboardOps'
      ) {
        this.showSearch = false;
      } else {
        this.showSearch = true;
      }
    });
  }

  deviceFunction() {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }

  setAction(actionFunction) {
    this.store.dispatch({
      type: TopbarActions.TOPBAR_CLICKED_ACTION,
      payload: actionFunction,
    });
  }

  ngOnDestroy() {
    this.isOpenSubscription.unsubscribe();
  }
}
